module.exports = __webpack_public_path__ + "img/fafs-logo.30eea14f.jpeg";